type JobPostLike = {
  corporate?: string;
  employmentType?: string;
  priorExperience?: string;
};

export default function* generateProperties(
  jobPost: JobPostLike,
): Generator<string, void, unknown> {
  if (jobPost.corporate) {
    const corporate = {
      KARROT_MARKET: '당근',
      KARROT_PAY: '당근페이',
    }[jobPost.corporate];
    if (corporate) {
      yield corporate;
    }
  }

  if (jobPost.employmentType) {
    const employmentType = {
      FULL_TIME: '정규직',
      CONTRACTOR: '계약직',
      INTERN: '인턴',
      ASSISTANT: '어시스턴트',
      PART_TIME: '파트타임',
    }[jobPost.employmentType];
    if (employmentType) {
      yield employmentType;
    }
  }

  if (jobPost.priorExperience) {
    const priorExperience = {
      YES: '경력',
      NO: '신입',
      WHATEVER: '경력/신입',
    }[jobPost.priorExperience];
    if (priorExperience) {
      yield priorExperience;
    }
  }
}
